import { render, staticRenderFns } from "./MdtTable.vue?vue&type=template&id=3ee4775c&scoped=true"
import script from "./MdtTable.vue?vue&type=script&lang=js"
export * from "./MdtTable.vue?vue&type=script&lang=js"
import style0 from "./MdtTable.vue?vue&type=style&index=0&id=3ee4775c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4775c",
  null
  
)

export default component.exports